// extracted by mini-css-extract-plugin
module.exports = {"knapp":"Knapp_knapp__maFDm","knapp__icon":"Knapp_knapp__icon__9dfIJ","knappFullWidth":"Knapp_knappFullWidth__e_uTC","lenkestyling":"Knapp_lenkestyling__SPCxp"};